import React from 'react'
import styled from 'styled-components'
import { bool, string } from 'prop-types'

import Loader from '@taglivros/oef_componentes/build/components/loader'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'


const WrapperLoader = styled.div`
  margin: 25px 0;

  > div {
    border-color: ${( { cor } ) => cor};
    border-left-color: ${StyleGuide.cores.branco};
  }
  
  @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 50px 0;
  }
`

const InlineLoader = ( { isCenter, cor } ) => {
  return (
    <WrapperLoader cor={ cor }>
      <Loader isCenter={ isCenter } />
    </WrapperLoader>
  )
}

InlineLoader.defaultProps = {
  'isCenter': false,
  'cor': StyleGuide.cores.azul
}

InlineLoader.propTypes = {
  'cor': string,
  'isCenter': bool
}

export default InlineLoader
